import React from "react";
import T from "prop-types";

export const ActionButton = ({ text, className, onClick, type }) => (
  <button style={{background:'#E3031F', whiteSpace: 'nowrap'}} onClick={onClick} className={className} type={type}>
    <span>{text}</span>
  </button>
);

ActionButton.T = {
  onClick: T.func,
  className: T.string,
  text: T.string,
};

ActionButton.defaultProps = {
  onClick: null,
  className: "actionButtonCls",
  text: "",
};
